import { render, staticRenderFns } from "./PCProduct.vue?vue&type=template&id=b2fbe310&scoped=true&"
import script from "./PCProduct.vue?vue&type=script&lang=js&"
export * from "./PCProduct.vue?vue&type=script&lang=js&"
import style0 from "./PCProduct.vue?vue&type=style&index=0&id=b2fbe310&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fbe310",
  null
  
)

export default component.exports